import { render, staticRenderFns } from "./Nazione.vue?vue&type=template&id=4a6b9230&"
import script from "./Nazione.vue?vue&type=script&lang=js&"
export * from "./Nazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports